
import React, { useEffect, useState } from 'react'
import DoneIcon from '@mui/icons-material/Done';
import {
  Box,
  Card,
  Container,
  Typography,
  Button,
  Avatar,
  Divider,
} from "@mui/material";
import {
  CheckCircle,
  CalendarMonth,
  Person,
  AccessTimeFilled,
  BusinessCenter,
  Email,
  Phone,
  LocationOn,
} from "@mui/icons-material";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getAppointmentDetails } from "../../store/crm/appointment";
import AppointmentReschedule from "../card-appointment/AppointmentReschedule";
import moment from "moment";
import { customConfirmation } from "../../services/utills";
import { cancelUserBooking } from "../../store/booking-widget";
import CustomModal from "../modal/customModal";
import RescheduleCalender from "../../pages/booking-widget/rescheduleCalender";
import CloseTab from "../../pages/booking-widget/closeTab";

const ConfirmationUI = ({ confirmation, setConfirmation, handleReset }) => {
 const [loading,setLoading] = useState(false)
     const [rescheduleData, setRescheduleData] = React.useState(null);
 
     const navigate = useNavigate()
     const dispatch = useDispatch()
     const user = useSelector((state) => state?.authStore?.user);
     const handleBook = () => {
         if (window.innerWidth >= 768) { // Assuming 768 pixels is the breakpoint for desktop screens
             window.location.href = user?.explore_services_url + "/#services";
           } else {
             window.location.href = "/home";
           }
     }
     
     const handleRescheduleAppointment = async () => {
 
         if (confirmation?.id) {
 
             if (await customConfirmation("Reschedule Appointment", " Would you like to reschedule?", "Yes, Reschedule", "Cancel")) {
                 setRescheduleData(confirmation)
                 // let res = await dispatch(cancelUserBooking())
             }  
         }
     }
 
     const handleScheduleClose = () => {
         setRescheduleData(null)
     }
 
     const handleCancel = async (item) => {
         if (confirmation?.id) { 
             if (await customConfirmation("Cancel Appointment", "Are you sure you want to cancel your appointment?")) {
                 setLoading(true)
                 let res = await dispatch(cancelUserBooking({booking_id: confirmation?.id,type:false}))
                 setLoading(false)
                 if (res?.payload?.success ==='true'){
                     const MySwal = withReactContent(Swal);
                     const result = await MySwal.fire({
                         title: '',
                         text: '',
                         showConfirmButton: false,
                         didOpen: () => {
                             // Directly access the swal popup and add styles
                             const popup = document.querySelector('.swal2-popup');
                             if (popup) {
                                 popup.style.maxWidth = '700px';
                                 popup.style.width = '100%';
                                 // Add more styles as needed
                             }
                         },
                         html:
                             <Box>
                                 <Box>
                                     <Box sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', p: '15px 15px'}}>
                                         <IconButton
                                             size="small"
                                             onClick={() => MySwal.close()}
                                         >
                                             <Close/>
                                         </IconButton>
                                     </Box>
                                 </Box>
                                 <Box sx={{p:'40px 20px'}}>
                                     <Typography  sx={{textAlign: "center",fontFamily: "helvetica-lt-std-bold", fontSize:'30px',fontWeight: '600'}}>
                                         Your appointment has been cancelled successfully!
                                     </Typography>
                                 </Box>
                             </Box>
                     });
 
                 }
             }
         }
     }
     const handleClose = () => {
         setRescheduleData(null)
     }
 
     const handleOpenGoogleMaps = (location) => {
         const encodedLocation = encodeURIComponent(location);
         window.open(`https://www.google.com/maps/search/?api=1&query=${encodedLocation}`, '_blank');
     };
     
     const handleCallPhoneNumber = (phoneNumber) => {
         window.location.href = `tel:${phoneNumber}`;
     };
     
 

  return (
    <>
      <CustomModal
        customWidth={"700px"}
        setOpen={() => handleClose()}
        open={!!rescheduleData?.id}
      >
        <Box>
          <RescheduleCalender
            handleClose={() => handleScheduleClose()}
            setLoading={setLoading}
            loading={loading}
            setConfirmation={setConfirmation}
            rescheduleData={rescheduleData}
          />
        </Box>
      </CustomModal>
      <Container
        sx={{
          py: 4,
          width: {
            xs: "100%", // For small screens
            sm: "100%", // Still full width on sm
            lg: "800px", // Acts like "md" on large screens
          },
          maxWidth: "100% !important", // prevent default maxWidth behavior
          paddingBottom:{sm:'50px', xs:'100px !important'},
          mx: "auto",
        }}
      >
        {/* Success Icon */}
                <Box sx={{textAlign:'center', width:{sm:'4rem', xs:'3rem'}, height:{sm:'4rem', xs:'3rem'},display:'flex', alignItems:'center', justifyContent:'center',background:' rgb(204 241 217)', borderRadius:'50%', margin:'0 auto'}}>

                <DoneIcon sx={{color:'rgb(22 163 74)'}}/>        
                </Box>

        {/* Main Title */}
        {confirmation?.status == "Pending Confirmation" ? (
          <Typography
            variant="h4"
            component="h1"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              color: "#1f2937",
              mb: 2,
              fontSize: { xs: "1.75rem", sm: "2.125rem" },
            }}
          >
            Appointment Request Received!
          </Typography>
        ) : (
          <Typography
            variant="h4"
            component="h1"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              color: "#1f2937",
              mb: 2,
              fontSize: { xs: "1.75rem", sm: "2.125rem" },
            }}
          >
            Appointment Confirmed!
          </Typography>
        )}

        {confirmation?.status == "Pending Confirmation" ? (
          <Typography
            variant="h6"
            sx={{
              fontFamily: "helvetica-lt-std-roman",
              color: "#000",
              textAlign: "center",
              mt: 1,
              fontSize: { sm: "1.25rem", xs: "1rem" },
            }}
          >
            Thank you for requesting an appointment on{" "}
            {confirmation?.date ? (
              <span>
                {moment(confirmation?.date).format("MMMM DD")} at{" "}
                {confirmation?.start_time}
              </span>
            ) : (
              <span style={{ color: "#F25022" }}>Time Not Set</span>
            )}
            <br />
            <span>
              We will review your request and get back to you shortly to confirm
              the booking.
              <br />
              If you need to update your requested time, feel free to reach out!
            </span>
          </Typography>
        ) : (
          <Typography
            variant="h6"
            sx={{
              fontFamily: "helvetica-lt-std-roman",
              color: "#000",
              textAlign: "center",
              mt: 1,
              fontSize: { sm: "1.25rem", xs: "1rem" },
            }}
          >
           We Look Forward to Seeing you !
          </Typography>
        )}

          <CloseTab/>

        {/* Main Card */}
        <Card
          sx={{
            p: 0,
            borderRadius: 2,
            mt:2,
            boxShadow:
              "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
            border: "1px solid #e5e7eb",
            overflow: "hidden",
            borderLeft: "4px solid #16a34a",
          }}
        >
          <Box sx={{ p: 3 }}>
            {/* Date & Time Section */}
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#6b7280",
                  textTransform: "uppercase",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  letterSpacing: "0.05em",
                  mb: 2,
                }}
              >
                DATE & TIME
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: 1,
                      backgroundColor: "#dcfce7",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 2,
                    }}
                  >
                    <CalendarMonth sx={{ color: "#16a34a", fontSize: 20 }} />
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: "#1f2937",
                        fontSize: "1.125rem",
                        mb: 0.5,
                      }}
                    >
                     {confirmation?.date ?
                                                                                          moment(confirmation?.date).format("dddd, MMMM D, YYYY")
                                                                                          : "Date and Time Not Set"
                                                                                      }
                    </Typography>
                    {confirmation?.date ? (
                      <Typography
                        variant="body1"
                        sx={{
                          color: "#6b7280",
                          fontSize: "1rem",
                        }}
                      >
                        {confirmation?.start_time} - {confirmation?.end_time}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Box>
                </Box>

               {/* Calendar Icon Button */}
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Appointment Details Section */}
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "#1f2937",
                  mb: 3,
                  fontSize: "1.25rem",
                }}
              >
                Appointment Details
              </Typography>

              {/* Customer */}
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: "#dbeafe",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                  }}
                >
                  <Person sx={{ color: "#2563eb", fontSize: 20 }} />
                </Box>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "0.875rem",
                      mb: 0.5,
                    }}
                  >
                    Customer
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      color: "#1f2937",
                      fontSize: "1rem",
                    }}
                  >
                    {confirmation?.customer?.name}
                  </Typography>
                </Box>
              </Box>

              {/* Service */}
              <Box sx={{ display: "flex", alignItems: "flex-start", mb: 3 }}>
                <Box
                  sx={{
                    width: {sm:40, xs:50},
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: "#f3e8ff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    mt: 0.5,
                  }}
                >
                  <BusinessCenter sx={{ color: "#7c3aed", fontSize: 20 }} />
                </Box>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "0.875rem",
                      mb: 0.5,
                    }}
                  >
                    Service
                  </Typography>
                  {confirmation?.services &&
                  confirmation.services.length > 0 ? (
                    <div>
                      {confirmation.services.map((service, index) => (
                        <div key={index}>
                          <Typography
                            variant="body1"
                            key={index}
                            sx={{
                              fontWeight: 600,
                              color: "#1f2937",
                              fontSize: "1rem",
                              lineHeight: 1.4,
                            }}
                          >
                            {service.name}
                          </Typography>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div>No services found</div>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Card>

        {/* Location Details Card */}
        <Card
          sx={{
            mt: 3,
            p: 3,
            borderRadius: 2,
            boxShadow:
              "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
            border: "1px solid #e5e7eb",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "#1f2937",
              mb: 3,
              fontSize: "1.25rem",
            }}
          >
            Location Details
          </Typography>

          {/* Clinic Info */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <Avatar
              sx={{
                width: 48,
                height: 48,
                backgroundColor: "#f3f4f6",
                color: "#1f2937",
                fontSize: "0.875rem",
                mr: 2,
              }}
              src={confirmation?.provider?.profile_image}
              alt={confirmation?.provider?.name.charAt(0) || "3"}
            />

            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "#1f2937",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
                onClick={() =>
                  handleOpenGoogleMaps(confirmation?.provider?.name)
                }
              >
                {confirmation?.provider?.name}
              </Typography>
              {/* <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <LocationOn sx={{ color: '#6b7280', fontSize: 16, mr: 0.5 }} />
              <Typography
                variant="body2"
                sx={{
                  color: '#6b7280',
                  fontSize: '0.875rem',
                }}
              >
                {appointmentData.clinicType}
              </Typography>
            </Box> */}
            </Box>
          </Box>

          {/* Contact Info */}
<Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
  <Email sx={{ color: "#6b7280", fontSize: 20, mr: 2 }} />
  {confirmation?.provider?.email && (
    <Typography
      variant="body1"
      sx={{
        color: "#1f2937",
        fontSize: "0.875rem",
      }}
    >
      <a 
        href={`mailto:${confirmation.provider.email}`} 
        style={{ color: "inherit", textDecoration: "none" }}
      >
        {confirmation.provider.email}
      </a>
    </Typography>
  )}
</Box>

<Box sx={{ display: "flex", alignItems: "center" }}>
  <Phone sx={{ color: "#6b7280", fontSize: 20, mr: 2 }} />
  {confirmation?.provider?.phone && (
    <Typography
      variant="body1"
      sx={{
        color: "#1f2937",
        fontSize: "0.875rem",
      }}
    >
      <a 
        href={`tel:${confirmation.provider.phone}`} 
        style={{ color: "inherit", textDecoration: "none" }}
      >
        {confirmation.provider.phone}
      </a>
    </Typography>
  )}
</Box>

          <Box
            sx={{
              mt: 3,
              pb: {
                xs: 3,
                md: 6,
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
              },
            }}
          >
            <Button
              onClick={() => handleRescheduleAppointment()}
              variant="contained"
              sx={{
                textTransform: "capitalize",
                fontSize: "16px",
                background: "#19a2ff",
                mt: 1,
                width: { sm: "auto", xs: "100%" },
              }}
            >
              Reschedule Appointment
            </Button>

            <Button
              variant="contained"
              sx={{
                background: "#f8fafc",
                color: "#000",
                border: "1px solid #e5d7d7",
                ml: { sm: 1, xs: 0 },
                textTransform: "capitalize",
                fontSize: "16px",
                mt: 1,
                width: { sm: "auto", xs: "100%" },
              }}
              onClick={() => handleBook()}
            >
              Book another Appointment
            </Button>
          </Box>
        </Card>
      </Container>
    </>
  );
};
export default ConfirmationUI;
